var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", { staticClass: "sidebar" }, [
    _c(
      "button",
      {
        staticClass: "toggle-nav",
        on: {
          click: function($event) {
            return _vm.toggleNav()
          }
        }
      },
      [
        _c("font-awesome-icon", {
          staticClass: "closed",
          attrs: { icon: "angle-right", "fixed-width": "" }
        }),
        _vm._v(" "),
        _c("font-awesome-icon", {
          staticClass: "open",
          attrs: { icon: "angle-left", "fixed-width": "" }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "sr-only sr-only-focusable" }, [
          _vm._v("Menu")
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "sidebar-inner" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("ClientSelection", {
          attrs: {
            "selected-clients": _vm.selectedClients,
            clients: _vm.clients
          },
          on: { cschange: _vm.clientSelectionChanged }
        }),
        _vm._v(" "),
        _c(
          "nav",
          { staticClass: "primary-nav" },
          [
            _c(
              "router-link",
              { attrs: { tag: "a", to: "/overview", exact: "" } },
              [
                _c("font-awesome-icon", {
                  staticClass: "icon",
                  attrs: { icon: "th", size: "lg", "fixed-width": "" }
                }),
                _vm._v("Overview\n      ")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "router-link",
              { attrs: { tag: "a", to: "/jobs" } },
              [
                _c("font-awesome-icon", {
                  staticClass: "icon",
                  attrs: { icon: "clipboard", size: "lg", "fixed-width": "" }
                }),
                _vm._v("Jobs\n      ")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "router-link",
              { attrs: { tag: "a", to: "/samples" } },
              [
                _c("font-awesome-icon", {
                  staticClass: "icon",
                  attrs: { icon: "vials", size: "lg", "fixed-width": "" }
                }),
                _vm._v("Samples\n      ")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "router-link",
              { attrs: { tag: "a", to: "/results" } },
              [
                _c("font-awesome-icon", {
                  staticClass: "icon",
                  attrs: { icon: "chart-pie", size: "lg", "fixed-width": "" }
                }),
                _vm._v("Results\n      ")
              ],
              1
            ),
            _vm._v(" "),
            _vm.hasAdminAccess()
              ? _c(
                  "router-link",
                  { attrs: { tag: "a", to: "/users" } },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "icon",
                      attrs: { icon: "users", size: "lg", "fixed-width": "" }
                    }),
                    _vm._v("Users\n      ")
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "router-link",
              { attrs: { tag: "a", to: "/settings" } },
              [
                _c("font-awesome-icon", {
                  staticClass: "icon",
                  attrs: { icon: "sliders-h", size: "lg", "fixed-width": "" }
                }),
                _vm._v("Settings\n      ")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "router-link",
              { attrs: { tag: "a", to: "/contact", exact: "" } },
              [
                _c("font-awesome-icon", {
                  staticClass: "icon",
                  attrs: { icon: "envelope", size: "lg", "fixed-width": "" }
                }),
                _vm._v("Contact\n      ")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "router-link",
              { attrs: { tag: "a", to: "/logout", exact: "" } },
              [
                _c("font-awesome-icon", {
                  staticClass: "icon",
                  attrs: { icon: "lock", size: "lg", "fixed-width": "" }
                }),
                _vm._v("Logout\n      ")
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "brand d-flex align-items-center" }, [
      _c("img", {
        staticClass: "img-fluid main-logo",
        attrs: { src: "/static/als-logo.png", alt: "ALS Ltd" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02d63560", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02d63560","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PortalSidebar.vue
// module id = Gvb4
// module chunks = 1